import { NextSeo } from 'next-seo'
import { Fragment } from 'react'

import NavigationBar from '@/components/NavigationBar'
import { ReleaseNotesContainer } from '../containers'
import { mq } from '@/styles/size'

function ReleaseNotesPage(): React.ReactElement {
  return (
    <Fragment>
      <NextSeo title="Release Notes" />
      <NavigationBar />
      <div
        css={{
          maxWidth: '1113px',
          margin: '0 auto',
          paddingTop: '120px',
          paddingBottom: '24px',
        }}
      >
        <h1
          css={mq({
            fontSize: [
              'var(--fs-500)',
              'var(--fs-500)',
              'var(--fs-570)',
              'var(--fs-600)',
            ],
          })}
        >
          Release Notes
        </h1>
        <ReleaseNotesContainer />
      </div>
    </Fragment>
  )
}

export default ReleaseNotesPage
